import { Users, Calendar, Workflow, Globe } from "lucide-react";

export const servicesDetailedData = [
  {
    id: "lead-generation",
    icon: <Users size={40} strokeWidth={1.5} />,
    title: "Lead Generation",
    tagline: "High-Quality Patients, Ready to Book",
    description:
      "We don't just drive traffic we attract patients who are ready to invest in their aesthetic goals. Through precision-targeted ads and conversions with our medically trained team, we fill your pipeline with qualified leads.",
    features: [
      "Meta & Google Ads campaigns tailored to aesthetic services",
      "Advanced audience targeting (location, demographics, interests)",
      "A/B tested ad creatives and landing pages",
      "Real-time lead tracking and CRM integration",
      "Consistent cost-per-lead optimization",
    ],
    results: "Our clients see 3-5x ROI within the first 90 days.",
    image:
      "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?q=80&w=1548&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Marketing analytics dashboard
  },
  {
    id: "social-media",
    icon: <Calendar size={40} strokeWidth={1.5} />,
    title: "Social Media & Calendar Management",
    tagline: "Your Brand, Always On",
    description:
      "Building a loyal community takes consistency. We manage your entire social presence from content creation to engagement while keeping your calendar booked with qualified appointments.",
    features: [
      "Community management and DM responses",
      "Before/after showcases and patient testimonials",
      "Automated appointment scheduling and reminders",
      "Calendar optimization to reduce no-shows",
    ],
    results: "Clinics gain 40% more engaged followers in 6 months.",
    image:
      "https://images.unsplash.com/photo-1611926653458-09294b3142bf?w=800&q=80", // Social media on phone
  },
  {
    id: "automations",
    icon: <Workflow size={40} strokeWidth={1.5} />,
    title: "Marketing Automations",
    tagline: "Work Smarter, Not Harder",
    description:
      "From the moment a lead clicks your ad to their post-treatment follow-up, our automation systems handle it all. Save time, reduce manual work, and never miss an opportunity.",
    features: [
      "Automated email & SMS sequences",
      "Lead nurturing workflows (pre-consult to post-treatment)",
      "Abandoned booking recovery automations",
      "Review request automations after appointments",
      "CRM integration (HubSpot, Go High Level, etc.)",
    ],
    results: "Clients recover 25% more abandoned bookings automatically.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80", // Workflow automation
  },
  {
    id: "website",
    icon: <Globe size={40} strokeWidth={1.5} />,
    title: "Website Design & Optimization",
    tagline: "Your Digital Storefront",
    description:
      "Your website should reflect the quality of your clinic. We design stunning, mobile-optimized sites that build trust, showcase results, and convert visitors into booked consultations.",
    features: [
      "Custom, mobile-first design tailored to aesthetics",
      "Fast-loading, SEO-optimized pages",
      "Integrated booking systems and live chat",
      "Before/after galleries and video testimonials",
      "Ongoing performance optimization and A/B testing",
    ],
    results: "Websites convert at 8-12%, vs. industry average of 2-4%.",
    image:
      "https://images.unsplash.com/photo-1547658719-da2b51169166?w=800&q=80", // Website design/laptop
  },
];
